<template>
  <div class="slider">
    <div class="container">
      <div class="callbacks_container">
        <swiper :options="swiperOption" class="swiper_Content" v-if="bannerList.length > 0">
          <swiper-slide v-for="item of bannerList" :key="item.id" class="rslides" id="slider3">
            <img :src="application.imageHost + item.imagePath" />
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>
    </div>
    <div class="clearfix"></div>
  </div>
</template>

<script>
import mixins from "../../common/mixin";
import application from "../../common/application";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
  name: "banner",
  components: {
    swiper,
    swiperSlide,
  },
  props: {
    bannerType: {
      type: String,
      required: true,
    },
  },
  mixins: [mixins],

  data: () => ({
    application: application,
    bannerList: [],

    swiperOption: {
      observer: true, //修改swiper自己或子元素时，自动初始化swiper
      observeParents: true, //修改swiper的父元素时，自动初始化swiper
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      autoplay: {
        delay: 5000,
        disableOnInterRaction: false,
      },
      loop: true,
    },
  }),
  created() {
    this.handleBannerList();
  },
  mounted() {},
  methods: {
    //获取轮播图列表
    handleBannerList: function () {
      let data = {
        pageIndex: 0,
        pageSize: 13,
        type: this.bannerType,
      };

      this.request({
        url: "/web/banner/list",
        data: data,
        success: (response) => {
          this.bannerList = response.data.records;
          console.log(this.bannerList);
        },
        error: (response) => {
          this.$Message.error(response.message);
        },
        complete: () => {},
      });
    },
  },
};
</script>

<style scoped>
@media (min-width: 1400px) {
  .rslides img {
    width: 100%;
    height: calc(100vw * 320 / 1440);
  }
  .slider {
  }
}

@media (min-width: 1200px) and (max-width: 1399px) {
  .rslides img {
    width: 100%;
    height: calc(100vw * 320 / 1440);
  }
  .slider {
  }
}
/**在768和1199像素之间的屏幕里，中等屏幕，分辨率低的PC**/
@media (min-width: 992px) and (max-width: 1199px) {
  .rslides img {
    width: 100%;
    height: calc(100vw * 320 / 1440);
  }
  .slider {
  }
}

/**在768和991像素之间的屏幕里，小屏幕，主要是PAD**/
@media (min-width: 768px) and (max-width: 991px) {
  .rslides img {
    width: 100%;
    height: 300px;
  }

  .slider {
  }
}

@media (max-width: 767px) {
  .slider {
    height: 200px;
  }
  .rslides img {
    width: 100%;
    height: 200px;
  }
  .min-height {
    height: 300px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/banner/banner.vue